import React, { useState } from 'react';

function FilterModal({ onFilter }) {
  const [status, setStatus] = useState('');
  const [email, setEmail] = useState('');
  const [fullname, setFullname] = useState('');

  const filterData = () => {
    onFilter(status, email, fullname);
    document.getElementById('closeModal').click();
  };

  return (
    <div className="modal" tabIndex="-1" id="exampleModal">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Filter Data</h5>
            <button
              id="closeModal"
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label className="fw-600 mb-10">Email</label>
              <input
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                type="text"
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label className="fw-600 mb-10">Customer Name</label>
              <input
                value={fullname}
                onChange={(e) => {
                  setFullname(e.target.value);
                }}
                type="text"
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label className="fw-600 mb-10">Status</label>
              <select
                className="form-control"
                value={status}
                onChange={(e) => {
                  setStatus(e.target.value);
                }}>
                <option value="">Semua Status</option>
                <option value="ACTIVE">Aktif</option>
                <option value="INACTIVE">Nonaktif</option>
              </select>
            </div>
          </div>
          <div className="modal-footer">
            <button
              onClick={filterData}
              type="button"
              className="btn btn-primary bg-blue-1 rounded-1">
              Filter Data
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FilterModal;
